
import { ComponentCreator, createComponentCreator, styleInject } from 'packages/css-component-modules';

const _css = `.Container_3f2d0c4866bcf031{padding-top:50px;background-color:#f0f3f3;margin-bottom:40px}.MarginTop_31312d2bbcf0d51c{margin-top:-30px}`;
styleInject(_css)

/** Container Props */
export type ContainerCCM = {
  /** Container Component Custom Properties */
  // No custom properties found

  /** Container Modifier Flags */
  // No modifiers classes found
};
/** Base Container component */
export const Container: ComponentCreator<ContainerCCM> = createComponentCreator({
  "name": "Container",
  "base": "Container_3f2d0c4866bcf031",
  "prop": {},
  "mod": {}
});


/** MarginTop Props */
export type MarginTopCCM = {
  /** MarginTop Component Custom Properties */
  // No custom properties found

  /** MarginTop Modifier Flags */
  // No modifiers classes found
};
/** Base MarginTop component */
export const MarginTop: ComponentCreator<MarginTopCCM> = createComponentCreator({
  "name": "MarginTop",
  "base": "MarginTop_31312d2bbcf0d51c",
  "prop": {},
  "mod": {}
});

